import { __decorate, __extends } from "tslib";
import { Editor } from '@tinymce/tinymce-react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import Dropzone from 'react-dropzone-uploader';
import { EndPoints, getAuthHeader, getBaseUrl, getImageUrl, UploadType } from '../../api';
import { createExtra, updateExtra } from '../../api/extras';
import { Button } from '../../components/Button';
import { Modal } from '../../components/Modal';
import { getEditorKey, getEditorOptions, isHtmlEmpty } from '../../utils/utils';
import S from './extras.styl';
var ExtrasDetailsModal = /** @class */ (function (_super) {
    __extends(ExtrasDetailsModal, _super);
    function ExtrasDetailsModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
            titleInputError: false,
            descriptionInputError: false,
            contentOneInputError: false,
            contentTwoInputError: false,
            imageError: false,
            editorOneState: '',
            editorTwoState: '',
        };
        _this.dropZone = null;
        _this.onChangeAction = function (e) {
            var name = e.currentTarget.name;
            if (name === 'title') {
                _this.setState({ titleInputError: false });
            }
            if (name === 'description') {
                _this.setState({ descriptionInputError: false });
            }
        };
        _this.isUpdated = function () {
            if (_this.props.isUpdated) {
                _this.props.isUpdated();
            }
        };
        _this.onClose = function () {
            if (_this.props.onClose) {
                _this.props.onClose();
            }
        };
        _this.getUploadParams = function (_) {
            return {
                url: getBaseUrl() + EndPoints.upload + '?type=' + UploadType.extra,
                headers: getAuthHeader(),
            };
        };
        _this.handleChangeStatus = function (params, status) {
            if (status === 'done') {
                var response = JSON.parse(params.xhr.response);
                _this.setState({
                    image: response.data.fileName,
                });
                _this.dropZone.files = [];
            }
        };
        return _this;
    }
    ExtrasDetailsModal.prototype.componentDidMount = function () {
        if (this.props.extra) {
            var extra = this.props.extra;
            this.setState({
                editorOneState: extra.contentOne || '',
                editorTwoState: extra.contentTwo || '',
                image: extra.image,
            });
        }
    };
    ExtrasDetailsModal.prototype.onSubmit = function (event) {
        var _this = this;
        event.preventDefault();
        var elements = event.currentTarget.elements;
        var valid = true;
        var title = elements.title.value;
        var description = elements.description.value;
        if (title.length === 0) {
            this.setState({ titleInputError: true });
            valid = false;
        }
        if (description.length === 0) {
            this.setState({ descriptionInputError: true });
            valid = false;
        }
        var contentOne = this.contentOneRef.getContent();
        if (isHtmlEmpty(contentOne)) {
            this.setState({ contentOneInputError: true });
            valid = false;
        }
        var contentTwo = this.contentTwoRef.getContent();
        if (isHtmlEmpty(contentTwo)) {
            contentTwo = '';
            // this.setState({contentTwoInputError: true});
            // valid = false;
        }
        var image = this.state.image;
        if (!image || image.length === 0) {
            // this.setState({imageError: true});
            // valid = false;
        }
        if (!valid) {
            return;
        }
        var request = {
            title: title,
            description: description,
            contentOne: contentOne,
            contentTwo: contentTwo,
            image: image,
        };
        this.setState({ loading: true });
        if (this.props.extra) {
            request.id = this.props.extra.id;
            updateExtra(request).then(function () {
                _this.setState({ loading: false });
                _this.isUpdated();
            }).catch(function (error) {
                _this.setState({ loading: false });
                alert(error);
            });
        }
        else {
            createExtra(request).then(function () {
                _this.setState({ loading: false });
                _this.isUpdated();
            }).catch(function (error) {
                _this.setState({ loading: false });
                alert(error);
            });
        }
    };
    ExtrasDetailsModal.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, state = _a.state;
        var i18n = props.store.i18n;
        var extra = props.extra;
        var loading = state.loading, editorOneState = state.editorOneState, editorTwoState = state.editorTwoState;
        return (React.createElement(Modal, { className: props.className, onRequestClose: props.onClose },
            React.createElement("div", { className: S.extrasAddView },
                React.createElement("p", { className: S.extrasHeaderText }, extra ?
                    i18n.extrasUpdateTitle
                    :
                        i18n.extrasCreateTitle),
                React.createElement("form", { className: "" + S.detailsDialogContent, method: "get", action: "/", onSubmit: this.onSubmit, noValidate: true },
                    React.createElement("div", null,
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitlePlaceholder),
                        React.createElement("div", { className: S.detailsInputWrapper },
                            React.createElement("label", { className: S.detailsInputTitle }, i18n.inputTitlePlaceholder),
                            React.createElement("input", { className: S.detailsInput + " textInput", name: "title", autoComplete: "title", onInput: this.onChangeAction, placeholder: i18n.inputTitlePlaceholder, defaultValue: extra === null || extra === void 0 ? void 0 : extra.title })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.titleInputError ? 'inputErrorActive' : '') }, i18n.inputDescriptionTitle),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputDescriptionTitle),
                        React.createElement("div", { className: S.detailsInputWrapper },
                            React.createElement("label", { className: S.detailsInputTitle }, i18n.inputDescriptionTitle),
                            React.createElement("input", { className: S.detailsInput + " textInput", name: "description", autoComplete: "description", onInput: this.onChangeAction, placeholder: i18n.inputDescriptionTitle, defaultValue: extra === null || extra === void 0 ? void 0 : extra.description })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.descriptionInputError ? 'inputErrorActive' : '') }, i18n.validationDescriptionError),
                        React.createElement("p", { className: "formSubtitle" },
                            i18n.inputTitleContent,
                            " #1"),
                        React.createElement(Editor, { onInit: function (_, editor) { return _this.contentOneRef = editor; }, apiKey: getEditorKey(), initialValue: editorOneState, init: getEditorOptions() }),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.contentOneInputError ? 'inputErrorActive' : '') }, i18n.validationContentError),
                        React.createElement("p", { className: "formSubtitle" },
                            i18n.inputTitleContent,
                            " #2 (",
                            i18n.settingsOptional,
                            ")"),
                        React.createElement(Editor, { onInit: function (_, editor) { return _this.contentTwoRef = editor; }, apiKey: getEditorKey(), initialValue: editorTwoState, init: getEditorOptions() }),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.contentTwoInputError ? 'inputErrorActive' : '') }, i18n.validationContentError),
                        React.createElement("p", { className: "formSubtitle" },
                            i18n.inputTitleIcon,
                            " (",
                            i18n.settingsOptional,
                            ")"),
                        React.createElement("div", { className: "formUploadWrapper" },
                            state.image ?
                                React.createElement("img", { className: "preview", src: getImageUrl(state.image) })
                                :
                                    '',
                            React.createElement(Dropzone, { ref: function (r) { return _this.dropZone = r; }, getUploadParams: this.getUploadParams, onChangeStatus: this.handleChangeStatus, multiple: false, inputContent: i18n.inputUploaderPlaceholder, canRestart: true, canCancel: false, canRemove: false, accept: "image/*" })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.imageError ? 'inputErrorActive' : '') }, i18n.validationImageError)),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.extrasModalButton, type: "submit", spinner: loading }, extra ?
                        i18n.actionUpdate
                        :
                            i18n.actionCreate),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.extrasModalButton + " " + S.extrasModalCancel, type: "button", spinner: loading, onClick: this.onClose }, i18n.alertModalCancel)))));
    };
    __decorate([
        action.bound
    ], ExtrasDetailsModal.prototype, "onSubmit", null);
    ExtrasDetailsModal = __decorate([
        inject('store'),
        observer
    ], ExtrasDetailsModal);
    return ExtrasDetailsModal;
}(React.Component));
export { ExtrasDetailsModal };
